import React, { useEffect } from 'react';
import { useState } from 'react';
import AdDelivery from './AdDelivery';
import './Adminn.css';
import AdProducts from './AdProducts';
import AdSliderLaptop from './AdSliderLaptop';
import AdSliderPhone from './AdSliderPhone';
import Logo from './img/logo/TC-LOGO.png';
import { useStateValue } from './StateProvider';

function Adminn() {
    const [ { admnavagationoption }, dispatch] = useStateValue();
    const [appear, setAppear] = useState(true);
    const [appear_2, setAppear_2] = useState(false);
    const [appear_3, setAppear_3] = useState(false);
    const [appear_4, setAppear_4] = useState(false);

    useEffect(() => {
    
        if(admnavagationoption === 'two'){
            document.getElementById("appear").style.display = "none";
            document.getElementById("appear_2").style.display = "none";
            document.getElementById("appear_3").style.display = "block";
            document.getElementById("appear_4").style.display = "none";
            setAppear(false);
            setAppear_2(false);
            setAppear_3(true);
            setAppear_4(false);
        }else if(admnavagationoption === 'three'){
            document.getElementById("appear").style.display = "none";
            document.getElementById("appear_2").style.display = "none";
            document.getElementById("appear_3").style.display = "none";
            document.getElementById("appear_4").style.display = "block";
            setAppear(false);
            setAppear_2(false);
            setAppear_3(false);
            setAppear_4(true);
        }

    }, [admnavagationoption])

    

    const happear = () => {
        document.getElementById("appear").style.display = "block";
        document.getElementById("appear_2").style.display = "none";
        document.getElementById("appear_3").style.display = "none";
        document.getElementById("appear_4").style.display = "none";
        setAppear(true);
        setAppear_2(false);
        setAppear_3(false);
        setAppear_4(false);
    }

    const happear_2 = () => {
        document.getElementById("appear").style.display = "none";
        document.getElementById("appear_2").style.display = "block";
        document.getElementById("appear_3").style.display = "none";
        document.getElementById("appear_4").style.display = "none";
        setAppear(false);
        setAppear_2(true);
        setAppear_3(false);
        setAppear_4(false);
    }

    const happear_3 = () => {
        document.getElementById("appear").style.display = "none";
        document.getElementById("appear_2").style.display = "none";
        document.getElementById("appear_3").style.display = "block";
        document.getElementById("appear_4").style.display = "none";
        setAppear(false);
        setAppear_2(false);
        setAppear_3(true);
        setAppear_4(false);   
    }

    const happear_4 = () =>{
        document.getElementById("appear").style.display = "none";
        document.getElementById("appear_2").style.display = "none";
        document.getElementById("appear_3").style.display = "none";
        document.getElementById("appear_4").style.display = "block";
        setAppear(false);
        setAppear_2(false);
        setAppear_3(false);
        setAppear_4(true);   
    }

    return (
        <div className='adminn'>
            <div className='adminn__containerleft'>
                <div className="adminn__logo" >
                    <img src={Logo} alt="logo"/>
                </div>
                <div className={appear ? 'adminn__btn active__btn' : 'adminn__btn disable__btn'} onClick={happear}>
                    <label>Slider Phone</label>
                </div>
                <div className={appear_2 ? 'adminn__btn active__btn' : 'adminn__btn disable__btn'} onClick={happear_2}>
                    <label>Slider laptop</label>
                </div>
                <div className={appear_3 ? 'adminn__btn active__btn' : 'adminn__btn disable__btn'} onClick={happear_3}>
                    <label>Products</label>
                </div>
                <div className={appear_4 ? 'adminn__btn active__btn' : 'adminn__btn disable__btn'} onClick={happear_4}>
                    <label>Delivery</label>
                </div>
            </div>
            <div id='appear' className='adminn__containerright ad__display'>
                <AdSliderPhone />
            </div>
            <div id='appear_2' className='adminn__containerright none__display'>
                <AdSliderLaptop />
            </div>
            <div id='appear_3' className='adminn__containerright none__display'>
                <AdProducts />
            </div>
            <div id='appear_4' className='adminn__containerright none__display'>
                <AdDelivery />
            </div>
        </div>
    )
}

export default Adminn;
